import React, { FC, useEffect } from 'react'
import { useSearchContext } from 'search/context/SearchContext'
import ErrorBoundary from '../../components/ErrorBoundary'
import { withAppLayout } from '../../parts/AppLayout/AppLayout'
import EmployeeApproveTable from './parts/EmployeesApproveTable'
import { SContainerWrapper, SWrapper } from './EmployeesApprovePage.styled'
import { SearchApprovesContextProvider } from './context/SearchApprovesContext'
import { FilterControls } from './parts/FilterControls'

export const EmployeesApprove: FC = () => {
    const { setSkills, setCompetencies, setSearchString } = useSearchContext()

    useEffect(() => {
        return () => {
            setSkills({})
            setCompetencies([])
            setSearchString('')
        }
    }, [])

    return (
        <SWrapper>
            <SContainerWrapper>
                <FilterControls />
                <EmployeeApproveTable />
            </SContainerWrapper>
        </SWrapper>
    )
}

export const EmployeesApprovePage: FC = withAppLayout(
    () => {
        return (
            <ErrorBoundary>
                <SearchApprovesContextProvider>
                    <EmployeesApprove />
                </SearchApprovesContextProvider>
            </ErrorBoundary>
        )
    },
    { wideView: true }
)
